import 'core-js/features/object';
import { platform } from './platform';
import { EventType, Question, Option } from '../EventTypes';

export interface AnalyticsProps {
  [K: string]: boolean | number | string | null | undefined;
}

export interface AnalyticsProperties {
  eventName: string;
  eventGuestCount?: number;
  eventHouseholdCount?: number;
  eventVisible?: boolean;
  rsvpPreference: string;
  platform: string;
  source: string;
  rsvpOnCount: number;
  product?: string;
  variant: string;
  rsvpOn: boolean;
}

export interface QuestionInteractionAnalyticsProperties {
  selection: string;
  questionCategory: string | null;
  questionType: string;
  questionPrompt: string;
  questionOptions: Option[] | null;
}

interface TrackQuestionInfo {
  selection: string;
  question: Question;
  isGeneralQuestion: boolean;
}

export const getAnalyticsProperties = (
  event: EventType,
  privateRsvp: boolean,
  rsvpOnCount: number
): AnalyticsProperties => {
  return {
    eventName: event.name,
    eventGuestCount: event.guestCount,
    eventHouseholdCount: event.householdCount,
    eventVisible: event.visible,
    rsvpPreference: privateRsvp ? 'secure' : 'public',
    platform: 'web',
    source: 'left nav',
    rsvpOnCount,
    product: process.env.SEGMENT_PRODUCT,
    variant: 'New RSVP Settings',
    rsvpOn: event.requireRsvp,
  };
};

const TextAnswerType = 'Text';
const CustomQuestionType = 'Custom';

export const getQuestionInteractionAnalyticsProperties = (
  selection: string,
  question: Question,
  isGeneralQuestion: boolean
): QuestionInteractionAnalyticsProperties => ({
  selection,
  questionCategory: question.type === CustomQuestionType ? null : question.type,
  questionType: `${isGeneralQuestion ? 'general' : 'event'} ${
    question.answerType === TextAnswerType ? 'open' : 'choice'
  }`,
  questionPrompt: question.text,
  questionOptions: question.options && question.answerType === 'Option' ? question.options : null,
});

export const track = (event: any, properties: any): void => {
  const amendedProperties = {
    platform,
    product: process.env.SEGMENT_PRODUCT,
    ...properties,
  };

  if ((window as any).analytics) {
    (window as any).analytics.track(event, amendedProperties);
  }
};

export const trackQuestionInteraction = (
  { selection, question, isGeneralQuestion }: TrackQuestionInfo,
  otherParams: object = {}
): void => {
  track('RSVP Settings Interaction', {
    ...getQuestionInteractionAnalyticsProperties(selection, question, isGeneralQuestion),
    ...otherParams,
  });
};
